import {Entity} from "../../../core/commons/entity";

export class FormImage implements Entity {
    id: number;
    data: string;
    created: number;
    name: string = "";

    constructor(o: Partial<FormImage>) {
        Object.assign(this, o);
    }
}



// WEBPACK FOOTER //
// ./src/app/forms/domain/meta/form-image.ts